import {get} from 'lodash'
import {isTrialAccountType} from 'helpers/user'
import {getAccountsIntegrationForUser} from 'helpers/accounting'
import {documentProviders} from "helpers/integrations"
import {canManagePlan} from "helpers/subscriptions"

export const getAuth = state => get(state, 'auth', null)

export const getUser = state => get(state, 'auth.user', {})

export const getAccountId = state => get(state, 'auth.user.accountId', null)

export const getUserSettings = state => state.auth.user.settings

export const getHomeCompanyId = state => get(state, 'auth.user.homeCompanyId', null)

export const isGoogleDriveIntegrated = state => state.auth.user.googleDriveIntegration

export const getAccountsIntegration = state => getAccountsIntegrationForUser(getUser(state))

export const getProSync = state => get(state, 'auth.user.proSync', false)

export const getMinimumMargin = state => get(state, 'auth.user.settings.minimumMargin', 0)

export const getAccessToken = state => get(state, 'auth.user.accessToken', null)

export const isAttemptingRefreshAuth = state => state.auth.attemptingRefreshAuth

export const getRefreshAuthError = state => state.auth.refreshAuthError

export const getRefreshAuthToken = state => state.auth.refreshAuthToken

export const showTrialBanner = (state) => {
  const user = getUser(state)
  return user &&
      isTrialAccountType(user)
      && canManagePlan(user)
}

export const isCancelling = (state) => {
  return state.auth.user.accountIsCancelling
}

export const getGlobalFeatureToggle = (state, featureToggle) => {
  return !!(state.auth.featureToggles || []).find(ft => ft === featureToggle)
}

export const getHomeCompanyLogoImageUrl = (state) => get(state, 'auth.user.companyLogoImage.url', null)

export const getUserSignatureImageUrl = (state) => get(state, 'auth.user.userSignatureImage.url', null)

export const getSettings = state => state.auth.user.settings

export const getDefaultDocumentProvider = state => {
  return isGoogleDriveIntegrated(state)
      ? documentProviders.GOOGLE_DRIVE
      : get(state, 'auth.user.defaultDocumentProvider')
}

export const getExcludeHomeCompany = state => get(state, 'auth.user.settings.excludeHomeCompanyFromReporting', false)

export const getSalesInvoicesRequiredFields = state => get(state, 'auth.user.settings.salesInvoicesRequiredFields')
export const getPurchaseInvoicesReferenceRequiredFields = state => get(state, 'auth.user.settings.purchaseInvoicesReferenceRequiredFields')

export const getPricingCalculatorAccessToken = state => get(state, 'auth.pricingCalculatorAccessToken', null)